import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { initializeApollo } from 'lib/apollo-client';
import { useMemo } from 'react';

const useApolloClient = (initialState: unknown): ApolloClient<NormalizedCacheObject> => {
  return useMemo(() => initializeApollo(initialState), [initialState]);
};

export default useApolloClient;
